import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ListPatientsBySearchTermsQuery } from '@insolution/graphql-data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalDateFormatPipe } from '@insolution/language-ui';

@Component({
  selector: 'lib-similar-patient-warning',
  imports: [TranslatePipe, RouterLink, LocalDateFormatPipe],
  templateUrl: './similar-patient-warning.html',
  styleUrl: './similar-patient-warning.scss',
})
export class SimilarPatientWarning {
  patients = input.required<ListPatientsBySearchTermsQuery['listPatientsBySearchTerms']['items']>();
}
